import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../config/settings";
import httpRequest from "../../utils/httpRequest";

const initialState = {
  userType: [],
  loading: false,
  error: null,
  roleNames: [],
};

export const createUserType = createAsyncThunk(
  "userType/createUserType",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/Account/create-admin-user`,
        "post",
        arg
      );
      if (response?.response?.data) {
        return response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchRoleNames = createAsyncThunk(
  "roleNames/fetchRoleNames",
  async () => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/Account/get-roles`,
        "post"
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
);

const userTypeSlice = createSlice({
  name: "userType",
  initialState,

  reducers: {
    setUserTypeDetails: (state, { payload }) => {
      state.userTypeDetails = payload;
    },
  },

  extraReducers: (builder) => {
    // Get all User Types
    builder.addCase(createUserType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createUserType.fulfilled, (state, action) => {
      state.loading = false;
      state.userType = action?.payload?.data;
    });
    builder.addCase(createUserType.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.error?.message;
    });

    // Get all roles
    builder.addCase(fetchRoleNames.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchRoleNames.fulfilled, (state, action) => {
      state.loading = false;
      state.events = action?.payload?.data;
    });
    builder.addCase(fetchRoleNames.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.error?.message;
    });
  },
});

export const { setUserTypeDetails } = userTypeSlice.actions;

export default userTypeSlice.reducer;
